// Recovered compiled webpack factory 20396. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      setCacheBustingSearchParam: function () {
        return i;
      },
      setCacheBustingSearchParamWithHash: function () {
        return s;
      },
    }));
  let n = r(13485),
    a = r(52486);
  async function o(e) {
    var t, r;
    return "function" ==
      typeof (null == (r = globalThis.crypto) || null == (t = r.subtle) ? void 0 : t.digest)
      ? (0, n.computeCacheBustingSearchParam)(
          e[a.NEXT_ROUTER_PREFETCH_HEADER],
          e[a.NEXT_ROUTER_SEGMENT_PREFETCH_HEADER],
          e[a.NEXT_ROUTER_STATE_TREE_HEADER],
          e[a.NEXT_URL],
        )
      : (0, n.computeLegacyCacheBustingSearchParam)(
          e[a.NEXT_ROUTER_PREFETCH_HEADER],
          e[a.NEXT_ROUTER_SEGMENT_PREFETCH_HEADER],
          e[a.NEXT_ROUTER_STATE_TREE_HEADER],
          e[a.NEXT_URL],
        );
  }
  let i = async (e, t) => {
      s(e, await o(t));
    },
    s = (e, t) => {
      let r = e.search,
        n = (r.startsWith("?") ? r.slice(1) : r)
          .split("&")
          .filter((e) => e && !e.startsWith("" + a.NEXT_RSC_UNION_QUERY + "="));
      (t.length > 0
        ? n.push(a.NEXT_RSC_UNION_QUERY + "=" + t)
        : n.push("" + a.NEXT_RSC_UNION_QUERY),
        (e.search = n.length ? "?" + n.join("&") : ""));
    };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
